import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { SiteService } from 'src/app/services/site.service';

@Component({
  selector: 'app-substitution-fields',
  templateUrl: './substitution-fields.component.html',
  styleUrls: ['./substitution-fields.component.scss']
})
export class SubstitutionFieldsComponent implements OnInit {
  @Input() showVimeoOption: boolean = true;
  @Input() additionalFields: string[] = [];
  
  public substitutionFields: string[] = [];
  public vimeoUrlVisible: boolean = false;
  public vimeoVideoId: string = '';

  constructor(
    private dataService: DataService,
    private siteService: SiteService
  ) {}

  ngOnInit(): void {
    this.dataService.getEmailTemplateFields().subscribe((data) => {
      this.substitutionFields = [...data, ...this.additionalFields];
    }, (error) => {
      console.error('Error loading substitution fields:', error);
      // Fallback to just additional fields if service call fails
      this.substitutionFields = [...this.additionalFields];
    });
  }

  copyToClipboard(field: string) {
    navigator.clipboard.writeText(field).then(() => {
      this.siteService.setMessage(`Copied "${field}" to clipboard`, 'success', 3000);
    }).catch((error) => {
      console.error('Failed to copy to clipboard:', error);
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = field;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this.siteService.setMessage(`Copied "${field}" to clipboard`, 'success', 3000);
    });
  }

  showCopyVimeoUrlDialog() {
    this.vimeoUrlVisible = true;
    this.vimeoVideoId = '';
  }

  copyVimeoUrl() {
    if (this.vimeoVideoId) {
      const vimeoUrl = `{{onemorningsite}}/video/${this.vimeoVideoId}`;
      navigator.clipboard.writeText(vimeoUrl).then(() => {
        this.siteService.setMessage(`Copied Vimeo URL to clipboard`, 'success', 3000);
        this.vimeoUrlVisible = false;
      }).catch((error) => {
        console.error('Failed to copy Vimeo URL to clipboard:', error);
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = vimeoUrl;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.siteService.setMessage(`Copied Vimeo URL to clipboard`, 'success', 3000);
        this.vimeoUrlVisible = false;
      });
    }
  }
}
